module.exports = __webpack_public_path__ + "assets/ic_no_tree.cc9b0500.svg";